import { Component, OnInit } from '@angular/core';
import { ElementoCatalogo } from 'src/app/models/entities/elemento-catalogo';

@Component({
  selector: 'grafica-pie',
  templateUrl: './grafica-pie.component.html',
  styleUrls: ['./grafica-pie.component.scss']
})
export class GraficaPieComponent implements OnInit {
  public data: any;
  constructor() { }

  ngOnInit() {
    this.data = {
      labels: ["Dato 1", "Dato 2", "Dato 3"],
      datasets: [
        {
          data: [1, 2, 3],
          backgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#CCFF00",
            "#CCFFCC",
            "#CC6600",
            "#CC66FF",
            "#FF6600",
            "#CC3333",
            "#CC0000",
            "#6633FF",
            "#666600",
            "#669900",
            "#66FF00",
            "#339966",
            "#003300"
          ],
          hoverBackgroundColor: [
            "#FF6384",
            "#36A2EB",
            "#FFCE56",
            "#CCFF00",
            "#CCFFCC",
            "#CC6600",
            "#CC66FF",
            "#FF6600",
            "#CC3333",
            "#CC0000",
            "#6633FF",
            "#666600",
            "#669900",
            "#66FF00",
            "#339966",
            "#003300"
          ]
        }]
    };
  }

}
